<template>
  <div class="error-page">
    <!-- Кнопка домой -->
    <HomeButton />
    
    <div class="error-page__wrapper">
        <div class="error-page__content">
            <h1 class="error-page__title">Ошибка оплаты</h1>
            <p class="error-page__message">{{ errorMessage }}</p>
        </div>
        <div class="error-page__buttons">
            <BaseButton
                text="Попробовать снова"
                styles="primary-gradient"
                :full-width="true"
                @on-submit="handleRetry"/>
        </div>
    </div>
  </div>
</template>

<script lang="ts" setup>
import { onBeforeMount, ref } from 'vue'
import router from '@/router'
import BaseButton from '@/ui/components/Base/BaseButton.vue'
import HomeButton from '@/ui/components/HomeButton.vue'
import { SentryService } from '@/shared/lib/sentry/sentryService'

const errorMessage = ref('Произошла ошибка при обработке платежа. Попробуйте еще раз.')

// Защита от прямого перехода на страницу ошибки
onBeforeMount(() => {
  // Проверяем, пришел ли пользователь с оплаты
  const paymentError = sessionStorage.getItem('paymentError')
  
  if (!paymentError) {
    // Логируем попытку прямого доступа к странице ошибки
    SentryService.setContext('error_page_direct_access', {
      reason: 'no_payment_error_flag',
      user_agent: navigator.userAgent,
      referrer: document.referrer
    })
    
    SentryService.captureMessage('Пользователь попытался напрямую перейти на страницу ошибки оплаты', 'warning')
    
    router.push('/')
    return
  }
  
  // Устанавливаем сообщение об ошибке если оно есть
  if (paymentError !== 'true') {
    errorMessage.value = paymentError
  }
  
  // Логируем достижение страницы ошибки
  SentryService.setContext('error_page_reached', {
    came_from_payment: true,
    error_message: errorMessage.value,
    original_error: paymentError
  })
  
  SentryService.captureMessage(`Пользователь достиг страницы ошибки оплаты: ${errorMessage.value}`, 'error')
  
  // Очищаем флаг после использования
  sessionStorage.removeItem('paymentError')
})

const handleRetry = () => {
    // Логируем попытку повторной оплаты
    SentryService.setContext('payment_retry_attempt', {
      previous_error: errorMessage.value,
      retry_method: 'error_page_button'
    })
    
    SentryService.captureMessage('Пользователь попытается повторить оплату после ошибки', 'info')
    
    // Возвращаемся на страницу оплаты
    sessionStorage.setItem('cameFromHome', 'true')
    router.push('/payment')
}
</script>

<style lang="scss" scoped>
@import '@/assets/styles/variables.scss';
@import '@/assets/styles/mixins.scss';

.error-page {
  height: 100%;
  padding: 40px 20px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  box-sizing: border-box;
  overflow-y: hidden;
  overflow-x: hidden;

  &__wrapper {
    width: 100%;
    max-width: 400px;
    display: flex;
    flex-direction: column;
    gap: 40px;
  }

  &__content {
    text-align: center;
  }

  &__title {
    @include h1;
    color: $neutral-100;
    margin: 0 0 16px 0;
  }

  &__message {
    @include p2-regular;
    color: $neutral-60;
    margin: 0;
    line-height: 1.5;
  }

  &__buttons {
    display: flex;
    flex-direction: column;
    gap: 16px;

    .button-base-block {
      display: flex;
      height: 48px;
    }
    
    .button-base {
      justify-content: center;
    }
  }
}

@media (max-width: 768px) {
  .error-page {
    padding: 20px 16px;

    &__wrapper {
      gap: 32px;
    }
  }
}
</style>
